import React from 'react';
import { CheckIcon } from 'lucide-react';
import { cuandoLlega, plata } from '../utils/format';
import { linkWhatsApp, textoWhatsApp } from '../utils/pedido';
import { WhatsAppIcon } from './WhatsAppIcon';
import type { Pedido, ProximaEntrega } from '../types/pedido';
interface Props {
  pedido: Pedido;
  entrega: ProximaEntrega | null;
  onOtroPedido: () => void;
}
export function Confirmacion({
  pedido,
  entrega,
  onOtroPedido
}: Props) {
  return <section aria-live="polite" className="mx-auto max-w-col pb-16 pt-8 text-center md:pt-12" data-id="element-26" data-mp="vnntaumvm4hp">
      <div className="mx-auto mb-5 grid place-items-center rounded-full bg-good-soft" style={{
      width: 60,
      height: 60
    }} data-id="element-27" data-mp="qq5ggt5qn54f">
        <CheckIcon className="h-7 w-7 text-good" strokeWidth={2.6} data-id="element-28" data-mp="15h4jzprpv3h5" />
      </div>

      <h2 className="display mb-2 text-[27px]" data-id="element-29" data-mp="10h0awkt51b0y">Pedido tomado</h2>
      <p className="mx-auto max-w-[34ch] text-[15px] text-ink-soft" data-id="element-30" data-mp="1eh1cy3l52oi0">
        Te lo dejamos {cuandoLlega(entrega)}. Te escribimos por WhatsApp para confirmar el horario.
      </p>

      <div className="my-6 rounded-card border border-line bg-surface p-[17px] text-left shadow-card" data-id="element-31" data-mp="2bz6z7q734vzk">
        <div className="mb-3 flex justify-between gap-2.5 border-b border-line pb-3 font-mono text-[11.5px] font-bold uppercase tracking-[0.08em] text-ink-faint" data-id="element-32" data-mp="2gwysoondoq5v">
          <span data-id="element-33" data-mp="2lz7nzrnq44b5">Pedido {pedido.id}</span>
          <span data-id="element-34" data-mp="2qw7s3x10iwzm">{pedido.ruta}</span>
        </div>

        {pedido.items.map(i => <div key={i.id} className="flex justify-between gap-3 py-[3px] text-[14.5px]" data-id="element-35" data-mp="2uy2vr86f1mgk">
            <span data-id="element-36" data-mp="2zwcs3m3vmt3r">
              {i.cant} × {i.nombre}
            </span>
            <span className="shrink-0 font-mono tnum" data-id="element-37" data-mp="2zu9q03pg99io">{plata(i.sub)}</span>
          </div>)}

        <div className="mt-2.5 flex justify-between gap-3 border-t border-line pt-3 text-base font-bold" data-id="element-38" data-mp="34pp3uvngj5f3">
          <span data-id="element-39" data-mp="3eliol2bby57y">Total</span>
          <span className="shrink-0 font-mono tnum" data-id="element-40" data-mp="3embllbkhlgcw">{plata(pedido.total)}</span>
        </div>

        <div className="mt-3 border-t border-dashed border-line pt-3 text-[13.5px] leading-relaxed text-ink-soft" data-id="element-41" data-mp="3imm41npgtz8n">
          <b className="font-semibold text-ink" data-id="element-42" data-mp="1jjf9r4tvi7bu">{pedido.direccion}</b>
          <br data-id="element-43" data-mp="1ejj656p38hwt" />
          {pedido.barrio}
          {pedido.entreCalles ? ` · entre ${pedido.entreCalles}` : ''}
          <br data-id="element-44" data-mp="1sb7cetcnoc5v" />
          Pagás con {pedido.pago.toLowerCase()} · {pedido.cliente}, {pedido.telefono}
          {pedido.notas && <>
              <br data-id="element-45" data-mp="1ninytwdyxh12" />
              Nota: {pedido.notas}
            </>}
        </div>
      </div>

      <a href={linkWhatsApp(textoWhatsApp(pedido))} target="_blank" rel="noopener" className="display-btn inline-flex items-center gap-2.5 rounded-field bg-accent px-[22px] py-3.5 text-[15px] text-accent-ink no-underline transition-colors duration-150 ease-soft hover:bg-accent-hover" data-id="element-46" data-mp="22ay991oov394">
        <WhatsAppIcon data-id="element-47" data-mp="gv8zufi9r7zw" />
        Mandarlo por WhatsApp también
      </a>

      <button type="button" onClick={onOtroPedido} className="mt-4 block w-full cursor-pointer border-none bg-transparent text-sm text-ink-soft underline underline-offset-[3px]" data-id="element-48" data-mp="gxlh0qg7debw">
        Hacer otro pedido
      </button>
    </section>;
}